import { createSlice } from '@reduxjs/toolkit';

// Create a Redux slice for the 'dashboard' portion of the state
export const dashboardSlice = createSlice({
  name: 'dashboard', // The name of the slice
  initialState: {
    dashboardInfo: {
      leadCount: 0,
      aiAgentUsageCount: 0,
      engagementCount: 0,
      viewCount: 0,
    },
  },
  reducers: {
    setDashboardInfo: (state, action) => {
      state.dashboardInfo = action.payload;
    },
  },
});

// Export the action creators
export const { setDashboardInfo } = dashboardSlice.actions;

// Export the reducer
export default dashboardSlice.reducer;
